import React, { useState } from "react";
import { Card } from "react-bootstrap";
import SocialIcon from "../../../NewsAndAnalysis/SocialIcon";
import {
  formatDate,
  getTime,
  getUniqueValuesFromList,
} from "../../../../utility/common-methods.jsx";
import {
  CONSTANTS,
  SOCIAL_SOURCES,
  TONE_LABEL,
  VERTICALS,
  DATE_FORMATS,
  LANGUAGE_CODES,
} from "../../../../constants/app-constant";
import ArticleTags from "../../News/ArticleTags";
import { TagsListModal } from "./TagsListModal";
import {
  LinkIcon,
  PlusIcon,
  TagClose,
  VideoPlayIcon,
} from "../../../Icons/icons.component";
import { FEED_DETAILS } from "../../../../constants/route-constants";
import Hashtags from "react-highlight-hashtags";
import LazyLoad from "react-lazy-load";
const { DATA_NOT_FOUND } = CONSTANTS;
const TagFeedItem = (props) => {
  const {
    attachments,
    channel_type,
    city,
    clientId,
    comment_count,
    country,
    created_at,
    dislike_count,
    entityName,
    etag,
    fav_count,
    favourites,
    from_username,
    id,
    is_recent_media,
    is_top_media,
    is_user_verified,
    is_visitor_feed,
    isModal,
    lang,
    latitude,
    like_count,
    longitude,
    media_link,
    media_type,
    message,
    page_details,
    page_id,
    permalink,
    reaction_count,
    removeTag,
    share_count,
    tags,
    thumbnail_link,
    title,
    tonality,
    type,
    updated_at,
    user_followers_count,
    vertical,
    verticalId,
    view_count,
    name,
  } = props;

  // const name = props.topic ? props.topic.name : entityName;
  const { display_picture } = page_details || {};
  const { V_BLOG, V_SOCIAL, V_FORUM } = VERTICALS;
  const { FACEBOOK, INSTAGRAM, YOUTUBE, TWITTER, PINTEREST } = SOCIAL_SOURCES;

  const [showAddTagListModal, setShowAddTagListModal] = useState(false);
  const [tagsList, setTagsList] = useState(props.tags);

  function truncate(source, size = 180) {
    return source && source.length > size
      ? source.slice(0, size - 1) + "…"
      : source;
  }

  const addTagClick = () => {
    setShowAddTagListModal(true);
  };

  const renderTags = () => {
    if (tagsList && tagsList.length) {
      return tagsList.map((tag) => {
        const tagName = tag.tag_name || tag.name;
        return (
          <>
            <span className="tagName">
              {tagName}
              <span
                onClick={() => removeTagFromList(tag.tag_id)}
                className="tagClose"
              >
                <TagClose />
              </span>
            </span>
          </>
        );
      });
    }
    return null;
  };

  const removeTagFromList = (tagId) => {
    const tagObject = tagsList
      .filter((i) => i.tag_id == tagId)
      .map((item) => {
        return {
          tag_id: item.tag_id,
          social_feed_id: id,
          channel_type: channel_type,
        };
      });
    setTagsList(tagsList.filter((i) => i.tag_id != tagId));
    removeTag(tagObject[0]);
  };

  const getAddedTag = (tags) => {
    setTagsList(getUniqueValuesFromList([...tagsList, ...tags], "tag_id"));
  };

  const handleFeedClick = () => {
    localStorage.clear();
    if (verticalId == V_BLOG || verticalId == V_FORUM) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/bafad/${clientId}-${channel_type}/${id}`,
        "_blank"
      );
    }

    if (verticalId == V_SOCIAL) {
      window.open(
        `https://${window.location.host}${FEED_DETAILS}/sad/${clientId}-${channel_type}/${id}`,
        "_blank"
      );
    }
  };

  const showFeedDivider =
    (display_picture || title || name || from_username) &&
    channel_type != VERTICALS.V_FORUM &&
    channel_type != VERTICALS.V_BLOG;
  const showMediaAttachments = () => {
    return Array.isArray(attachments) && attachments.length
      ? attachments.map((src, index) => {
          if (!src) {
            return null;
          }
          const { media_link, media_type } = src;
          if (media_type === "image") {
            return (
              <div className="imgThumbWrap">
                <div className="imgThumb">
                  <img alt={""} key={src} src={media_link} />
                </div>
              </div>
            );
          }
          if (media_type === "video") {
            return (
              <div className="videoThumb">
                <VideoPlayIcon />
                <a href={permalink} target="_blank">
                  <img src={media_link} alt="NA" />
                </a>
              </div>
            );
          }
          return null;
        })
      : "";
  };
  const pageTitle =
    channel_type == YOUTUBE
      ? name
      : channel_type == TWITTER
      ? `@${from_username}`
      : channel_type == PINTEREST
      ? from_username
      : page_details && page_details.name;

  const gotoPermalink = () => {
    if (!permalink) return;
    window.open(permalink, "_blank");
  };

  const renderSocialFeed = () => {
    const { display_picture, name = "" } = page_details || {};
    return (
      <>
        <div className="headlineWrapper">
          <div className="feedInfoHeader">
            <div className="feedNamePic">
              {display_picture && (
                <img src={display_picture} className="feedPic" />
              )}
              {/* <span className="feedName" onClick={() => handleFeedClick()}>{title}</span> */}
              <span className="feedName">{name || pageTitle || ""}</span>
            </div>
            {(name || pageTitle || display_picture) && channel_type && (
              <span className="feedDivider"></span>
            )}
            <div className="feedChannelDate">
              <SocialIcon type={channel_type} />
              <span className="newsDate"></span>
            </div>
          </div>
          <div className="rightContainer">
            <ul className="dropDownContainer">
              <li className="themeLi tlLink">
                <span onClick={gotoPermalink} className="linkIcon clickable">
                  <div className="hasTooltip">
                    <LinkIcon />
                    <span className="tooltipWrap left">Go to Page</span>
                  </div>
                </span>
              </li>
              <ArticleTags
                article={props}
                hideTheme
                callSocialAPI
                showFavouriteTag
                isSocial
              />
            </ul>
          </div>
        </div>
        <div className="feedDetails" onClick={() => handleFeedClick()}>
          {channel_type == YOUTUBE ? (
            <Hashtags text={title || ""} />
          ) : (
            <Hashtags text={truncate(message)} />
          )}
        </div>
        <div className="imgContainer videoContainer">
          <LazyLoad offsetVertical="1000">
            <>
              {thumbnail_link && (
                <div className="videoThumb">
                  <VideoPlayIcon />
                  <a href={permalink} target="_blank">
                    <img src={thumbnail_link} alt="NA" />
                  </a>
                </div>
              )}
            </>
          </LazyLoad>
          {showMediaAttachments()}
        </div>
        <div className="metaTagsWrap" key={id + "1"}>
          {(channel_type == INSTAGRAM ||
            channel_type == FACEBOOK ||
            channel_type == YOUTUBE ||
            channel_type == TWITTER) && (
            <>
              <div className="mtWrap">
                <span className="label-span hoverable">Likes : </span>
                <span>{like_count}</span>
              </div>
              {channel_type == YOUTUBE && (
                <div className="mtWrap">
                  <span className="label-span">Dislikes :</span>{" "}
                  <span>{dislike_count}</span>
                </div>
              )}
            </>
          )}
          {channel_type == TWITTER && (
            <div className="mtWrap">
              <span className="label-span">Retweets :</span>{" "}
              <span>{share_count}</span>
            </div>
          )}
          <div className="mtWrap">
            <span className="label-span">Comments :</span>{" "}
            <span>{comment_count}</span>
          </div>
          {channel_type == FACEBOOK && (
            <div className="mtWrap">
              <span className="label-span">Share :</span>{" "}
              <span>{share_count}</span>
            </div>
          )}
          {channel_type == YOUTUBE && (
            <div className="mtWrap">
              <span className="label-span">Views :</span>{" "}
              <span>{view_count}</span>
            </div>
          )}
          <div className="mtWrap">
            <span className="label-span">Publish Date :</span>{" "}
            <span>
              {formatDate(new Date(created_at), DATE_FORMATS.DDMMYYYY_dash)}
            </span>
          </div>
          <div className="mtWrap mtAddTag">
            <span
              onClick={() => setShowAddTagListModal(true)}
              className="addTag"
            >
              Add Tag <PlusIcon />{" "}
            </span>
            <div className="tagList">{renderTags()}</div>
          </div>
        </div>
      </>
    );
  };

  const renderBlogAndForumFeed = () => {
    return (
      <>
        <div className="headlineWrapper">
          <div className="feedInfoHeader">
            <div className="feedNamePic">
              {page_details && page_details.display_picture && (
                <img src={page_details.display_picture} className="feedPic" />
              )}
              {/* <span className="feedName" onClick={() => handleFeedClick()}>{title}</span> */}
              <span className="feedName" onClick={() => handleFeedClick()}>
                {(page_details && page_details.name) || title || ""}
              </span>
            </div>
            {/* <span className="feedDivider"></span> */}
            <div className="feedChannelDate">
              <SocialIcon type={channel_type} />
              <span className="newsDate"></span>
            </div>
          </div>
          <div className="rightContainer">
            <ul className="dropDownContainer">
              <ArticleTags
                article={props}
                hideTheme
                callSocialAPI
                showFavouriteTag
                isBlogAndForum
              />
            </ul>
          </div>
        </div>

        <div className="imgContainer videoContainer">
          <LazyLoad offsetVertical="1000">
            <>
              {thumbnail_link && (
                <div className="videoThumb">
                  <VideoPlayIcon />
                  <a href={permalink} target="_blank">
                    <img src={thumbnail_link} alt="NA" />
                  </a>
                </div>
              )}
            </>
          </LazyLoad>
          {showMediaAttachments()}
        </div>
        <div className="card-entities metaTagsWrap" key={id + "1"}>
          <div className="mtWrap">
            <span className="label-span hoverable">
              {channel_type == V_BLOG && "Blog :"}
              {channel_type == V_FORUM && "Forum :"}
            </span>
            <span className="link" onClick={gotoPermalink}>
              {name || "NA"}
            </span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Author :</span>{" "}
            <span>{from_username || "NA"}</span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Language :</span>{" "}
            <span>{LANGUAGE_CODES[lang] || "NA"}</span>
          </div>
          <div className="mtWrap">
            <span className="label-span">Publish Date :</span>{" "}
            <span>
              {formatDate(new Date(created_at), DATE_FORMATS.DDMMYYYY_dash)}
            </span>
          </div>
          {verticalId == V_FORUM && (
            <div className="mtWrap">
              <span className="label-span">Comments :</span>{" "}
              <span>{comment_count}</span>
            </div>
          )}
          <div className="mtWrap mtAddTag">
            <span
              onClick={() => setShowAddTagListModal(true)}
              className="addTag"
            >
              Add Tag <PlusIcon />{" "}
            </span>
            <div className="tagList">{renderTags()}</div>
          </div>
        </div>
      </>
    );
  };

  const renderFeeds = () => {
    if (verticalId == V_SOCIAL) {
      return renderSocialFeed();
    } else if (verticalId == V_BLOG || verticalId == V_FORUM) {
      return renderBlogAndForumFeed();
    } else {
      return null;
    }
  };

  return (
    <>
      {showAddTagListModal && (
        <TagsListModal
          show={showAddTagListModal}
          onCancel={() => setShowAddTagListModal(false)}
          feedDetail={props}
          addedTag={getAddedTag}
        />
      )}
      <Card className="innerFeedItem socialFeedItem tagFeedItem" body key={id}>
        {renderFeeds()}
      </Card>
    </>
  );
};

export default TagFeedItem;
